/**
 * Backsplash models
 * @readonly
 * @enum {string}
 */
const BacksplashModelNumber = {
  LCHD700: 'LCHD700',
  LCHD900: 'LCHD900',
  LCHD1000: 'LCHD1000',
  LCHD1100: 'LCHD1100',
  LCHD1400: 'LCHD1400',
  LCHD1500: 'LCHD1500',
  LCHD1800: 'LCHD1800',
  LCHD2200: 'LCHD2200',
};
Object.freeze(BacksplashModelNumber);

/**
 * Base burners
 * @readonly
 * @enum {string}
 */
const BaseBurners = {
  threeFeuxClassique: '3feuxClas',
  threeFeuxClassiqueRev: '3feuxClasRev',
  threeFeuxTraditional: '3feuxTrad',
  threeFeuxTraditionalRev: '3feuxTradRev',
  fourFeuxClassique: '4feuxClas',
  fourFeuxClassiqueSully: '4feuxClasSully',
  fiveFeuxClassique: '5feuxClas',
  fiveFeuxTraditional: '5feuxTrad',
  sixFeuxClassique: '6feuxClas',
  sixFeuxClassiqueRev: '6feuxClasRev',
};
Object.freeze(BaseBurners);

/**
 * Optional burners
 * @readonly
 * @enum {string}
 */
const Burner = {
  eighteenK: '18k',
  electricPlancha: 'LAE010TPK',
  elevenK: '11k',
  fifteenK: '15k',
  fiveK: '5k',
  flameGrill: 'LAG010CK',
  gasBurner: 'burner',
  multiCooker: 'LAE010CVA',
  one18kBurner: 'LAG010UR',
  stainlessSteelWorkstation: 'ss',
  traditionalSimmerPlate: 'LAG010CF',
  two11kBurners: 'LAG020UR',
  two15kBurners: 'LAG024UR',
  twoInductionRings: 'LAE020I',
};
Object.freeze(Burner);

/**
 * Range and hood colors
 * @readonly
 * @enum {string}
 */
const Color = {
  anthracite: 'an',
  ardoise: 'ard',
  armor: 'ar',
  britishRacingGreen: 'brg',
  burgundyRed: 'br',
  canardBlue: 'cab',
  chantilly: 'ct',
  chocolat: 'ch',
  coralBlue: 'cb',
  customColor: 'cc',
  delftBlue: 'db',
  englishCreme: 'ec',
  faience: 'fa',
  frangipane: 'fr',
  frenchBlue: 'fb',
  griotte: 'gr',
  ivory: 'iv',
  mandarine: 'ma',
  marronGlace: 'mg',
  matteBlack: 'mb',
  olive: 'ol',
  plum: 'pl',
  portugueseBlue: 'pb',
  provenceYellow: 'py',
  roseQuartz: 'rq',
  shinyBlack: 'sb',
  stainlessSteel: 'ss',
  terracotta: 'tc',
  tilleul: 'ti',
  vertSilice: 'vsi',
  vertSologne: 'vs',
  white: 'wh',
};
Object.freeze(Color);

/**
 * Cupboard types
 * @readonly
 * @enum {string}
 */
const Cupboard = {
  warming: 'warm',
  storage: 'store',
};
Object.freeze(Cupboard);

/**
 * Hood duct cover finishes
 * @readonly
 * @enum {string}
 */
const DuctCover = {
  color: 'color',
  stainlessSteel: 'stainlessSteel',
};
Object.freeze(DuctCover);

/**
 * Gas type
 * @readonly
 * @enum {string}
 */
const Gas = {
  propane: 'lpg',
  naturalGas: 'ng',
  notSure: 'unsure',
};
Object.freeze(Gas);

/**
 * Hood duct cover finishes
 * @readonly
 * @enum {string}
 */
const HoodDuctCoverFinish = {
  color: 'color',
  stainlessSteel: 'ss',
};
Object.freeze(HoodDuctCoverFinish);

/**
 * Hood duct cover height (in millimeters)
 * @readonly
 * @enum {string}
 */
const HoodDuctCoverHeight = {
  twoFifty: '250',
  fiveHundred: '500',
  sevenFifty: '750',
  oneThousand: '1000',
};
Object.freeze(HoodDuctCoverHeight);

/**
 * Hood insert types
 * @readonly
 * @enum {string}
 */
const HoodInsertChoice = {
  modernAire: 'ma',
  ventAHoodSingle: 'vah1',
  ventAHoodDual: 'vah2',
  ventAHoodMagicLung: 'vahml',
};
Object.freeze(HoodInsertChoice);

/**
 * Hood insert types
 * @readonly
 * @enum {string}
 */
const HoodInsertModel = {
  modernAire_PSL900: 'modern-aire-PSL900',
  modernAire_PSL1100: 'modern-aire-PSL1100',
  modernAire_PSL1200: 'modern-aire-PSL1200',
  modernAire_PSL1300: 'modern-aire-PSL1300',
  modernAire_PSL1700: 'modern-aire-PSL1700',
  modernAire_PSL2000: 'modern-aire-PSL2000',
  modernAire_PSL2400: 'modern-aire-PSL2400',
  ventAHood_BH228SLD: 'vent-a-hood-BH228SLD',
  ventAHood_BH234SLD: 'vent-a-hood-BH234SLD',
  ventAHood_BH240SLD: 'vent-a-hood-BH240SLD',
  ventAHood_BH346SLD: 'vent-a-hood-BH346SLD',
  ventAHood_M28SLD_single: 'vent-a-hood-M28SLD-single',
  ventAHood_M34SLD_single: 'vent-a-hood-M34SLD-single',
  ventAHood_M40SLD_single: 'vent-a-hood-M40SLD-single',
  ventAHood_M46SLD_single: 'vent-a-hood-M46SLD-single',
  ventAHood_M28SLD_dual: 'vent-a-hood-M28SLD-dual',
  ventAHood_M34SLD_dual: 'vent-a-hood-M34SLD-dual',
  ventAHood_M40SLD_dual: 'vent-a-hood-M40SLD-dual',
  ventAHood_M46SLD_dual: 'vent-a-hood-M46SLD-dual',
};
Object.freeze(HoodInsertModel);

/**
 * Hood models
 * @readonly
 * @enum {string}
 */
const HoodModelNumber = {
  LH900: 'LH900',
  LH1100: 'LH1100',
  LH1200: 'LH1200',
  LH1300: 'LH1300',
  LH1600: 'LH1600',
  LH1700: 'LH1700',
  LH2000: 'LH2000',
  LH2400: 'LH2400',
};
Object.freeze(HoodModelNumber);

/**
 * Label names for range parts
 * @readonly
 * @enum {string}
 */
const LabelName = {
  leftCupboard: 'left-cupboard-label',
  leftOven: 'left-oven-label',
  rightCupboard: 'right-cupboard-label',
  rightOven: 'right-oven-label',
  storageDrawer: 'storage-drawer-label',
  verticalConvection: 'vertical-convection-label',
};
Object.freeze(LabelName);

/**
 * Maximum label widths for range parts
 * @readonly
 * @enum {number}
 */
const LabelWidth = {
  clunyOven: 0.45,
  clunyStorageDrawer: 0.29,
  cupboard: 0.35,
  sullyOven: 0.62,
  volnayCupboard: 0.3,
  volnayOven: 0.54,
};
Object.freeze(LabelWidth);

/**
 * Various coordinates for label positions
 * @readonly
 * @enum {number}
 */
const LabelPosition = {
  frontZPos: 0.33,
  storeDrawerYPos: 0.23,
};
Object.freeze(LabelPosition);

/**
 * Range lines
 * @readonly
 * @enum {string}
 */
const Line = {
  classique: 'clas',
  moderne: 'mod',
};
Object.freeze(Line);

/**
 * Three.js mesh names for important 3D objects
 * @readonly
 * @enum {string}
 */
const MeshName = {
  aerationVentBlack: 'Aeration_Vent_Black',
  backSpacer: 'Back_Spacer',
  backSpacerBlack: 'Back_Spacer_Black',
  backsplash: 'Backsplash',
  backsplashBarSupport1: 'Backsplash_Bar_Support_1',
  backsplashBarSupport2: 'Backsplash_Bar_Support_2',
  backsplashBarSupport3: 'Backsplash_Bar_Support_3',
  backsplashPotRailBar: 'Backsplash_Pot_Rail_Bar',
  backsplashZHook1: 'Backsplash_Z_Hook_1',
  backsplashZHook2: 'Backsplash_Z_Hook_2',
  classiqueAerationVent: 'Aeration_Vent_Classique',
  classiqueCupboardDoorBar: 'Cupboard_Door_Bar_Classique',
  classiqueClunyOvenDoorBar: 'Oven_Door_Bar_Classique_Cluny',
  classiqueSullyOvenDoorBar: 'Oven_Door_Bar_Classique_Sully',
  classiqueVolnayOvenDoorBar: 'Oven_Door_Bar_Classique_Volnay',
  classiqueKnob: 'Knob_Classique',
  clunyOvenDoor: 'Oven_Door_Cluny',
  clunyStorageDrawer: 'Storage_Drawer_Cluny',
  controlPanel: 'Control_Panel',
  cupboardDoor: 'Cupboard_Door',
  cupboardDoorBar: 'Cupboard_Door_Bar',
  cupboardBarLeftSupport: 'Cupboard_Bar_Support_Left',
  cupboardBarRightSupport: 'Cupboard_Bar_Support_Right',
  cupboardVentCover: 'Cupboard_Vent_Cover',
  cupboardVentCoverBlack: 'Cupboard_Vent_Cover_Black',
  cupboardVentCoverGroup: 'cupboard-vent-cover-group',
  doorBarLeftSupport: 'Door_Bar_Support_Left',
  doorBarRightSupport: 'Door_Bar_Support_Right',
  drawerLeftPull: 'Drawer_Pull_Left',
  drawerPull: 'Drawer_Pull',
  drawerRightPull: 'Drawer_Pull_Right',
  electricOvenBackPanel: 'Back_Panel_Electric_Oven',
  gasOvenBackPanel: 'Back_Panel_Gas_Oven',
  gasOvenChimneyBackPanel: 'Back_Panel_Gas_Oven_Chimney',
  hoodBackPanel: 'Hood_Back_Panel',
  hoodBody: 'Hood_Body',
  hoodDuctCover: 'Duct_Cover',
  hoodDuctCover250: 'Duct_Cover_250',
  hoodDuctCover500: 'Duct_Cover_500',
  hoodDuctCover750: 'Duct_Cover_750',
  hoodDuctCover1000: 'Duct_Cover_1000',
  hoodLowerBeam: 'Hood_Lower_Beam',
  leftCooktopHingePlate: 'Cooktop_Hinge_Plate_Left',
  leftCupboardDoor: 'Left_Cupboard_Door',
  leftCupboardBarLeftSupport: 'Left_Cupboard_Bar_Support_Left',
  leftCupboardBarRightSupport: 'Left_Cupboard_Bar_Support_Right',
  leftCupboardVentCover: 'Left_Cupboard_Vent_Cover',
  leftDrawerLeftPull: 'Left_Drawer_Pull_Left',
  leftDrawerRightPull: 'Left_Drawer_Pull_Right',
  leftOvenDoor: 'Left_Oven_Door',
  leftOvenDoorBarLeftSupport: 'Left_Oven_Door_Bar_Support_Left',
  leftOvenDoorBarRightSupport: 'Left_Oven_Door_Bar_Support_Right',
  leftOvenMiniVentCover: 'Left_Oven_Mini_Vent_Cover',
  leftOvenVentCover: 'Left_Oven_Vent_Cover',
  leftStorageDrawer: 'Left_Storage_Drawer',
  logo: 'Lacanche_Logo',
  logoBorder: 'Logo_Border',
  logoPlate: 'Logo_Plate',
  logoScrews: 'Logo_Screws',
  mavBaffleFilter: 'MAV_Baffle_Filter',
  mavInsertHousing: 'MAV_Insert_Housing',
  mavKnob: 'MAV_Knob',
  mavLedLens: 'MAV_LED_Lens',
  moderneAerationVent: 'Aeration_Vent_Moderne',
  moderneClunyDrawerBottomLip: 'Drawer_Bottom_Lip_Moderne_Cluny',
  moderneClunyOvenDoorBar: 'Oven_Door_Bar_Moderne_Cluny',
  moderneCupboardDoorBar: 'Cupboard_Door_Bar_Moderne',
  moderneDoorBarSupport: 'Door_Bar_Support_Moderne',
  moderneSullyDrawerBottomLip: 'Drawer_Bottom_Lip_Moderne_Sully',
  moderneSullyOvenDoorBar: 'Oven_Door_Bar_Moderne_Sully',
  moderneVolnayCupboardDoorBar: 'Cupboard_Door_Bar_Moderne_Volnay',
  moderneVolnayDrawerBottomLip: 'Drawer_Bottom_Lip_Moderne_Volnay',
  moderneVolnayOvenDoorBar: 'Oven_Door_Bar_Moderne_Volnay',
  moderneKnob: 'Knob_Moderne',
  ovenDoor: 'Oven_Door',
  ovenDoorBar: 'Oven_Door_Bar',
  ovenDoorBarLeftSupport: 'Oven_Door_Bar_Support_Left',
  ovenDoorBarRightSupport: 'Oven_Door_Bar_Support_Right',
  ovenVentCover: 'Oven_Vent_Cover',
  ovenVentCoverBlack: 'Oven_Vent_Cover_Black',
  ovenVentCoverGroup: 'oven-vent-cover-group',
  petiteOvenDoor: 'Petite_Oven_Door',
  petiteOvenDoorBar: 'Petite_Oven_Door_Bar',
  petiteOvenDoorBarLeftSupport: 'Petite_Oven_Door_Bar_Support_Left',
  petiteOvenDoorBarRightSupport: 'Petite_Oven_Door_Bar_Support_Right',
  rangeBackPanel: 'Back_Panel_Range',
  rangeBase: 'Range_Base',
  rangeSides: 'Range_Sides',
  rangeTop: 'range-top',
  rangeTop700: '700_Range_Top',
  rangeTop900: '900_Range_Top',
  rangeTop1000: '1000_Range_Top',
  rangeTopRim1100: '1100_Range_Top_Rim',
  rangeTopRim1400: '1400_Range_Top_Rim',
  rangeTopRim1500: '1500_Range_Top_Rim',
  rangeTopRim1800: '1800_Range_Top_Rim',
  rangeTopRim2200: '2200_Range_Top_Rim',
  rightCooktopHingePlate: 'Cooktop_Hinge_Plate_Right',
  rightCupboardDoor: 'Right_Cupboard_Door',
  rightCupboardBarLeftSupport: 'Right_Cupboard_Bar_Support_Left',
  rightCupboardBarRightSupport: 'Right_Cupboard_Bar_Support_Right',
  rightCupboardVentCover: 'Right_Cupboard_Vent_Cover',
  rightDrawerLeftPull: 'Right_Drawer_Pull_Left',
  rightDrawerRightPull: 'Right_Drawer_Pull_Right',
  rightOvenDoor: 'Right_Oven_Door',
  rightOvenDoorBarLeftSupport: 'Right_Oven_Door_Bar_Support_Left',
  rightOvenDoorBarRightSupport: 'Right_Oven_Door_Bar_Support_Right',
  rightOvenMiniVentCover: 'Right_Oven_Mini_Vent_Cover',
  rightOvenVentCover: 'Right_Oven_Vent_Cover',
  rightStorageDrawer: 'Right_Storage_Drawer',
  storageDrawer: 'Storage_Drawer',
  sullyOvenDoor: 'Oven_Door_Sully',
  sullyStorageDrawer: 'Storage_Drawer_Sully',
  toeKick: 'Toe_Kick',
  towelBar: 'Towel_Bar',
  towelBarCenterSupport: 'Towel_Bar_Support_Center',
  towelBarleftSupport: 'Towel_Bar_Support_Left',
  towelBarMidLeftSupport: 'Towel_Bar_Support_Mid_Left',
  towelBarMidRightSupport: 'Towel_Bar_Support_Mid_Right',
  towelBarRightSupport: 'Towel_Bar_Support_Right',
  vahDecoupeSpacer: 'VAH_Decoupe_Spacer',
  vahFanShield: 'VAH_Fan_Shield',
  vahInsertHousing: 'VAH_Insert_Housing',
  vahKnobBand: 'VAH_Knob_Band',
  vahKnobFanIcon: 'VAH_Knob_Fan_Icon',
  vahKnobFan: 'VAH-fan-knob',
  vahKnobLight: 'VAH_Knob_Light',
  vahLightBase: 'VAH_Light_Base',
  vahLightLens: 'VAH_Light_Lens',
  vctBackPanel: 'Back_Panel_VCT',
  vctBackPanelTop: 'Back_Panel_VCT_Top',
  volnayCupboardDoor: 'Cupboard_Door_Volnay',
  volnayOvenDoor: 'Oven_Door_Volnay',
  volnayStorageDrawer: 'Storage_Drawer_Volnay',
};
Object.freeze(MeshName);

/**
 * Messages to the user regarding illegal configurations
 * @readonly
 * @enum {string}
 */
const Message = {
  exceedsMaxRangeAmps:
    "Selecting that option would exceed the range's 60 amps maximum. Talk to your salesperson about exceeding this limit.",
  flameGrillOverVCT:
    'A Flame Grill is not allowed over a Vertical Convection Oven.',
  inductionRingsOverGasOven: 'Induction Rings are not allowed over a gas oven.',
  inductionRingsInProhibitedPosition:
    'This range cannot have Induction Rings in that position next to a Traditional Range Top.',
  leftElectricRightGasOvens:
    'If you want gas and electric ovens, the left oven must be gas.',
  multiCookerOverWarmingCupboard:
    'A multi-cooker is not allowed over a warming cupboard - only over a storage cupboard.',
  multiCookerOverVCT:
    'A multi-cooker is not allowed over a vertical convection oven - only over a storage cupboard.',
  planchaOverGasOven: 'An electric plancha is not allowed over a gas oven.',
  traditionalPlateNextTo4Feux:
    'This range cannot have a Traditional Simmer Plate on the right of a 4 Feux Range Top.',
  wideBurnerInNarrowPosition:
    'A "wide" burner is not allowed to the left of a Classique or Traditional Range Top.',
};
Object.freeze(Message);

/**
 * Range height options
 * @readonly
 * @enum {string}
 */
const RangeHeight = {
  '35_38': '35_38',
  36: '36',
  '36_58': '36_58',
  '37_316': '37_316',
  '37_1316': '37_1316',
  '38_38': '38_38',
  39: '39',
  '39_916': '39_916',
  '40_316': '40_316',
  notSure: 'unsure',
  other: 'other',
};
Object.freeze(RangeHeight);

/**
 * Lacanche range model names
 * @readonly
 * @enum {string}
 */
const RangeModel = {
  beaune: 'beaune',
  bussy: 'bussy',
  chagny: 'chagny',
  chagny1400left: 'chagny1400G',
  chagny1400right: 'chagny1400D',
  chagny1800: 'chagny1800',
  chambertin: 'chambertin',
  chassagne: 'chassagne',
  citeaux: 'citeaux',
  cluny: 'cluny',
  cluny1400left: 'cluny1400G',
  cluny1400right: 'cluny1400D',
  cluny1800: 'cluny1800',
  cormatin: 'cormatin',
  fontenay: 'fontenay',
  rully: 'rully',
  saulieu: 'saulieu',
  savigny: 'savigny',
  sully: 'sully',
  sully1800left: 'sully1800G',
  sully1800right: 'sully1800D',
  sully2200: 'sully2200',
  volnay: 'volnay',
  vougeot: 'vougeot',
};
Object.freeze(RangeModel);

/**
 * Spaces for optional burners
 * @readonly
 * @enum {string}
 */
const OptionSpace = {
  option1: 'option1',
  option2: 'option2',
  option3: 'option3',
  option4: 'option4',
};
Object.freeze(OptionSpace);

/**
 * Oven types
 * @readonly
 * @enum {string}
 */
const Oven = {
  convection: 'elcon',
  convectionAlt: 'elconAlt',
  electric: 'elec',
  gas: 'gas',
  grande: 'grande',
  leftVertConv: 'leftConv',
  petite: 'petite',
  rightVertConv: 'rightConv',
  vertConv: 'conv',
};
Object.freeze(Oven);

/**
 * Placment for optional burners
 * @readonly
 * @enum {string}
 */
const Placement = {
  l1: 'l1',
  l2: 'l2',
  r1: 'r1',
  r2: 'r2',
};
Object.freeze(Placement);

/**
 * Oven types
 * @readonly
 * @enum {string}
 */
const Position = {
  back: 'back',
  center: 'center',
  front: 'front',
  left: 'left',
  leftBack: 'left-back',
  leftFront: 'left-front',
  right: 'right',
  rightBack: 'right-back',
  rightFront: 'right-front',
};
Object.freeze(Position);

/**
 * Range top styles
 * @readonly
 * @enum {string}
 */
const RangeTop = {
  classique: 'clas',
  traditional: 'trad',
  fourFeux: '4feux',
  classiqueRev: 'rev',
};
Object.freeze(RangeTop);

/**
 * Range regions
 * @readonly
 * @enum {string}
 */
const Region = {
  farLeft: 'farLeft',
  left: 'left',
  center: 'center',
  right: 'right',
  farRight: 'farRight',
};
Object.freeze(Region);

/**
 * Back Spacer mounting positions
 * @readonly
 * @enum {string}
 */
const Spacer = {
  raised: 'raised',
  flush: 'flush',
};
Object.freeze(Spacer);

/**
 * Summary tabs
 * @readonly
 * @enum {string}
 */
const Tab = {
  range: 'range',
  hood: 'hood',
  backsplash: 'backsplash',
};
Object.freeze(Tab);

/**
 * Range trims
 * @readonly
 * @enum {string}
 */
const Trim = {
  brass: 'br',
  brushedSS: 'ss',
  chrome: 'chr',
  nickel: 'ni',
};
Object.freeze(Trim);

export {
  BacksplashModelNumber,
  BaseBurners,
  Burner,
  Color,
  Cupboard,
  DuctCover,
  Gas,
  HoodDuctCoverFinish,
  HoodDuctCoverHeight,
  HoodInsertChoice,
  HoodInsertModel,
  HoodModelNumber,
  LabelName,
  LabelPosition,
  LabelWidth,
  Line,
  MeshName,
  Message,
  RangeHeight,
  RangeModel,
  OptionSpace,
  Oven,
  Placement,
  Position,
  RangeTop,
  Region,
  Spacer,
  Tab,
  Trim,
};
